"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  DEFAULT_TENANT: true
};
exports.DEFAULT_TENANT = void 0;
var _enviromentCodes = require("./enviromentCodes");
Object.keys(_enviromentCodes).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _enviromentCodes[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _enviromentCodes[key];
    }
  });
});
const DEFAULT_TENANT = exports.DEFAULT_TENANT = 'uk';
//# sourceMappingURL=index.js.map